var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Alert from "@cloudscape-design/components/alert";
import { v4 as uuidv4 } from "uuid";
import "../NotificationList.css";
import classNames from "classnames";
/**
 * This is the basic notification list component.
 * You can maintain notification items in your own store in external application. Make sure to provide id and onDismiss to each notification item.
 * Useful store hook can be found in /hook/useNotificationListStore.ts.
 */
export var NotificationList = function (_a) {
    var _b = _a.shadowEffect, shadowEffect = _b === void 0 ? false : _b, items = _a.items, ariaLabel = _a.ariaLabel;
    return (_jsx("div", __assign({ "aria-label": ariaLabel }, { children: items.map(function (item, index) {
            var _a, _b;
            return (_jsx("div", __assign({ className: classNames("notification-wrapper", {
                    notification_list_shadow: shadowEffect,
                }) }, { children: _jsx(Alert, __assign({ type: (_a = item.type) !== null && _a !== void 0 ? _a : "info", header: item.header, statusIconAriaLabel: item.statusIconAriaLabel, dismissible: item.dismissible, dismissAriaLabel: item.dismissAriaLabel, action: item.action, "data-testid": item.id, onDismiss: item.onDismiss }, { children: item.content })) }), (_b = item.id) !== null && _b !== void 0 ? _b : index));
        }) })));
};
/**
 * This is the notification list component with default state management and provides default id (uuid) with onDismiss to each item.
 * It can be used if you don't need your own state management and simply want to display/dismiss notification list on screen.
 */
export var DefaultNotificationList = function (_a) {
    var items = _a.items, ariaLabel = _a.ariaLabel;
    var _b = useState(items), notificationList = _b[0], setNotificationList = _b[1];
    var onDismiss = function (id) {
        setNotificationList(function (notificationList) {
            console.log("Dismissed notification", id);
            return notificationList.filter(function (notification) { return notification.id !== id; });
        });
    };
    useEffect(function () {
        var newItems = items.map(function (item) {
            // Add uuid as id to each notification item if it's not provided
            item.id = item.id === undefined ? uuidv4() : item.id;
            // Auto remove notification item when onDismiss is called
            item.onDismiss = function () {
                onDismiss(item.id);
            };
            return item;
        });
        setNotificationList(newItems);
    }, [JSON.stringify(items)]);
    return _jsx(NotificationList, { items: notificationList, ariaLabel: ariaLabel });
};
